import PropTypes from 'prop-types';
import { Grid } from '../../grid';
import styles from './Headline.scss';

export const Headline = ({ title, children = [] }) => {
  const [serviceTitle, appointmentTitle] = title.split(': ');

  return (
    <div className={styles.HeadlineWrapper}>
      <Grid.Container className={styles.Container}>
        <h1 className={styles.Headline} data-testid="Title">
          {appointmentTitle ? (
            <>
              <span>{serviceTitle}:</span>
              <span>{appointmentTitle}</span>
            </>
          ) : (
            title
          )}
        </h1>
        {children}
      </Grid.Container>
    </div>
  );
};

Headline.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};
